import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/button.module';
import { ModalModule } from '../modal/modal.module';
import { IconModule } from '../icon/icon.module';
import { AccountAmountCardComponent } from './account-amount-card.component';

@NgModule({
  imports: [CommonModule, ModalModule, IconModule, ButtonModule],
  exports: [AccountAmountCardComponent],
  declarations: [AccountAmountCardComponent],
})
export class AccountAmountCardModule {}
